import { Form, Input } from "antd";
import { RuleUICondition } from "models/rules";
import { FC } from "react";

export interface ConditionProps {
    index: number;
}

export const AlwaysCondition = ({ index }: ConditionProps) => <>
    <Form.Item>
        {/* just used for uniform spacing */}
    </Form.Item>
    <Form.Item
        label="Always"
        colon={false}
        name={[index, '$ICondition']} initialValue="AlwaysCondition">
        <Input hidden />
    </Form.Item>
</>;

export const ContainsCondition = ({ index }: ConditionProps) => <>
    <Form.Item name={[index, '$ICondition']} initialValue="ContainsCondition">
        <Input hidden />
    </Form.Item>
    <Form.Item
        name={[index, 'term']}
        label="When the card title contains the term"
        rules={[{ required: true, message: "term is required!" }]}>
        <Input />
    </Form.Item>
</>

export const DoesNotContainCondition = ({ index }: ConditionProps) => <>
    <Form.Item name={[index, '$ICondition']} initialValue="DoesNotContainCondition">
        <Input hidden />
    </Form.Item>
    <Form.Item
        name={[index, 'term']}
        label="When the card title does NOT contain the term"
        rules={[{ required: true, message: "term is required!" }]}>
        <Input />
    </Form.Item>
</>

export const LengthLteCondition = ({ index }: ConditionProps) => <>
    <Form.Item name={[index, '$ICondition']} initialValue="LessThanOrEqualToLengthCondition">
        <Input hidden />
    </Form.Item>
    <Form.Item
        name={[index, 'length']}
        label="When the card title length is less than or equal to"
        rules={[{ required: true, message: "length is required!" }]}>
        <Input type="number" />
    </Form.Item>
</>;

export const LengthGteCondition = ({ index }: ConditionProps) => <>
    <Form.Item name={[index, '$ICondition']} initialValue="GreaterThanOrEqualToLengthCondition">
        <Input hidden />
    </Form.Item>
    <Form.Item
        name={[index, 'length']}
        label="When the card title length is greater than or equal to"
        rules={[{ required: true, message: "length is required!" }]}>
        <Input type="number" />
    </Form.Item>
</>;

export const ConditionMap: Record<RuleUICondition, FC<ConditionProps>> = {
    [RuleUICondition.Unknown]: () => <></>,
    [RuleUICondition.Always]: AlwaysCondition,
    [RuleUICondition.Contains]: ContainsCondition,
    [RuleUICondition.DoesNotContain]: DoesNotContainCondition,
    [RuleUICondition.TitleLengthLtE]: LengthLteCondition,
    [RuleUICondition.TitleLengthGtE]: LengthGteCondition
};